const jsonSchema = [
  {
    name: 'date',
    label: 'Date',
    type: 'date',
    required: true,
    showInList: true
  },
  {
    type: 'group',
    fields: [
      {
        name: 'startTime',
        label: 'Start Time',
        type: 'time',
        showInList: true
      },
      {
        name: 'endTime',
        label: 'End Time',
        type: 'time',
        showInList: false
      }
    ]
  },

  {
    name: 'name',
    label: 'Name',
    type: 'multiselect',
    showInList: true
  },
  {
    name: 'coach',
    label: 'Coach',
    type: 'text',
    showInList: true
  },
  {
    name: 'maxCapacity',
    label: 'Max Capacity',
    type: 'number',
    showInList: false
  }

  // Add more fields as needed
];
export default jsonSchema;
